export default __webpack_public_path__ + "static/media/statusUnknown.0816214f.png";